// Jen typy a defaulty bez zod: runtime schémata žijí v `schemas/homepage.ts` (řez 13,
// Kontrakt 4(a)), takže `types/**` za běhu na zod nedosáhne.
import type { z } from "zod";
import type {
  DestRefSchema,
  HitRefSchema,
  HomepageSettingsSchema,
  PromoBarSettingsSchema,
  TripTypeImageIdsSchema,
} from "../schemas/homepage";

export type HitRef = z.infer<typeof HitRefSchema>;
export type DestRef = z.infer<typeof DestRefSchema>;
export type PromoBarSettings = z.infer<typeof PromoBarSettingsSchema>;

/** Výchozí (vypnutá) lišta — JEDINÝ default pro seed nastavení i pro shovívavé čtení. */
export const DEFAULT_PROMO_BAR: PromoBarSettings = { enabled: false, text: "", href: "" };

export type TripTypeImageIds = z.infer<typeof TripTypeImageIdsSchema>;

/**
 * JEDINÝ default tří fotek karet — pro seed nastavení I pro veřejné čtení.
 *
 * Proč i pro veřejné čtení: `defaultSettings` v `admin/settings.ts` se merguje POUZE
 * v administračním GET. Veřejná routa `/api/homepage` čte syrové řádky přes výčtový
 * allowlist a řádek `homepage.tripTypeImageIds` v D1 po nasazení NEEXISTUJE (žádná
 * migrace ho nezakládá) — s defaultem jen v administraci by se karty vykreslily bez
 * fotek, dokud by někdo neuložil stránku Úvodní stránka. Týž vzor drží `DEFAULT_PROMO_BAR`.
 *
 * HRANICE FALLBACKU JE ŘÁDEK, NE POLE: default platí, jen když řádek v `settings`
 * CHYBÍ. Existuje-li, platí jeho hodnoty včetně explicitních `null` — vyprázdněný
 * picker znamená „karta bez fotky", ne tichý návrat fotografie, kterou operátor odebral.
 *
 * Přiřazení konkrétních fotek je provizorní (vznikly pro jiné tři karty a ani jedna
 * nezobrazuje moře) — výběr nových je redakční práce, ne obsah řezu.
 */
export const DEFAULT_TRIP_TYPE_IMAGE_IDS: TripTypeImageIds = {
  guided: "med_mq2ciusmai2gyj",
  private: "med_mpms3pieq4uiqw",
  resort: "med_mpms3ka5gzaxrx",
};

export type HomepageSettings = z.infer<typeof HomepageSettingsSchema>;
